import React from 'react';

type Props = {
  onClick: Function,
  content: string,
  dataId?: string,
  alignTop?: boolean,
};

function ButtonLink(props: Props) {
  const { onClick, content, dataId, alignTop } = props;
  return (
    <button
      type="button"
      className="u__default-link"
      style={{ verticalAlign: alignTop ? 'top' : 'middle' }}
      onClick={onClick}
      data-automation-id={dataId && dataId}
    >
      {content}
    </button>
  );
}

ButtonLink.defaultProps = {
  dataId: null,
  alignTop: null,
};

export default ButtonLink;
